import {GET_IpAddress} from '../constants/ActionTypes'

const INIT_STATE = {
    IpAddress: null,
    loading: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_IpAddress:
            return {
                IpAddress: action.body,
                loading :false
            }
        default:
            return state;
    }
}